import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import gql from 'graphql-tag';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { familia } from 'src/app/shared/object/familia.model';
import { formato } from 'src/app/shared/object/formato.model';
import { impuesto } from 'src/app/shared/object/impuesto.model';
import { lista_precio_detalle } from 'src/app/shared/object/lista_precio_detalle.model';
import { producto } from 'src/app/shared/object/producto.model';
import { producto_formatoJoin } from 'src/app/shared/object/producto_formatoJoin.model';
import { producto_impuesto } from 'src/app/shared/object/producto_impuesto.model';
import { producto_impuestoJoin } from 'src/app/shared/object/producto_impuestoJoin.model';
import { rubro } from 'src/app/shared/object/rubro.model';
import { unidad_medida } from 'src/app/shared/object/unidad_medida.model';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { ToastService } from 'ng-uikit-pro-standard';
import { ProductoModalSeleccionarImpuestoComponent } from "../modal-seleccionar-impuesto/modal-seleccionar-impuesto.component";
import { ParametroEmpresaService } from "src/app/services/parametro-empresa.service";
import { MessageRendererService } from "src/app/services/message-renderer.service";
import { AuditoriaInput } from "src/app/views/configuracion-sistema/auditoria/lista-auditoria/lista-auditoria.component";

@Component({
  selector: 'app-productos-modal-resumen',
  templateUrl: './modal-resumen.component.html',
  styleUrls: ['../productos.component.scss'],
  providers: [SecurityService, ValidadoresService]
})
export class ProductosModalResumenComponent implements OnInit {

  private client: GraphQLClient = null;

  // Modales
  @ViewChild('resumenProducto', { static: true }) resumenProductoModal: ModalDirective;
  @ViewChild(ProductoModalSeleccionarImpuestoComponent, { static: true }) modalSeleccionarImpuestos: ProductoModalSeleccionarImpuestoComponent

  // Form && Main Data
  formResumen: FormGroup;
  rut_empresa: number;
  sucursal_codigo: number;
  producto: producto

  // Data
  public codigo_impuesto: number = 0;

  listaProductoFormatoResumen: producto_formatoJoin[];

  public neto_1: number;
  public neto_2: number;
  public neto_3: number;
  public neto_4: number;
  public neto_5: number;

  public margen_1: number;
  public margen_2: number;
  public margen_3: number;
  public margen_4: number;
  public margen_5: number;

  public impuestoAdicPro: number;
  public parametro_iva: number;

  public iva1: number;
  public impAdicional1: number;
  public preciofinal1: number;

  public iva2: number;
  public impAdicional2: number;
  public preciofinal2: number;

  public iva3: number;
  public impAdicional3: number;
  public preciofinal3: number;

  public iva4: number;
  public impAdicional4: number;
  public preciofinal4: number;

  public iva5: number;
  public impAdicional5: number;
  public preciofinal5: number;

  optionsFormatoProducto: Array<any> = [];
  public parametroNegocio: boolean = false;

  auditoria: AuditoriaInput;

  // Utils
  private log: any
  currentTabs: string;

  constructor(client: GraphQLClient,
    private formBuilder: FormBuilder,
    private accesolocalstorage: SecurityService,
    public validadores: ValidadoresService,
    private toastrService: ToastService,
    private parametroEmpresaService: ParametroEmpresaService,
    private messageRendererService: MessageRendererService,
  ) {
    this.client = client;
  }

  ngOnInit() {
    this.rut_empresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursal_codigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.currentTabs = "detalle";
    this.createForm()
    this.formChangesSubscriptions()
  }

  verDetalle(){
    this.currentTabs = "detalle";
    console.log('Detalle');
  }
  verAuditoria(){
    this.currentTabs = "auditoria";
    this.auditoria = {
      codigoEntidad: this.producto.codigo,
      entidad: 'PRODUCTO'
    }
  }

  parametroUnidadNegocio() {
    this.parametroEmpresaService.permiteUnidadNegocio(this.rut_empresa, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      this.parametroNegocio = respuesta.valor_bool
      //this.log('Permite Unidad Negocio', this.parametroNegocio)
    })
  }

  createForm() {
    this.formResumen = this.formBuilder.group({
      producto_codigo: [''],
      empresa_rut: [''],
      sku: [''],
      descripcion: [''],
      descripcion_ext: [''],
      es_exento: [''],
      codigo_barras: [''],
      fecha_registro: [''],
      activo: [''],
      favorito: [''],
      familia: [''],
      unidad_negocio: [''],
      tipo_producto_codigo: [''],
      unidad_medida: [''],
      afecto_reglas_comerciales: [''],
      fecha_caducidad_combo: [''],
      fecha_inicio_combo: [''],
      rubro: [''],
      formato: [''],
    });
  }

  formChangesSubscriptions() {
    this.formResumen.get("formato").valueChanges.subscribe(data => {
      let productoCodigo = this.formResumen.controls["producto_codigo"].value;
      let formato = this.formResumen.controls["formato"].value;
      if (productoCodigo != null && formato != null) {
        this.neto_1 = 0
        this.neto_2 = 0
        this.neto_3 = 0
        this.neto_4 = 0
        this.neto_5 = 0
        this.margen_1 = 0
        this.margen_2 = 0
        this.margen_3 = 0
        this.margen_4 = 0
        this.margen_5 = 0
        this.iva1 = 0
        this.impAdicional1 = 0;
        this.preciofinal1 = 0;
        this.iva2 = 0
        this.impAdicional2 = 0;
        this.preciofinal2 = 0;
        this.iva3 = 0
        this.impAdicional3 = 0;
        this.preciofinal3 = 0;
        this.iva4 = 0
        this.impAdicional4 = 0;
        this.preciofinal4 = 0;
        this.iva5 = 0
        this.impAdicional5 = 0;
        this.preciofinal5 = 0;
        this.obtenerListaPrecioxFormato(productoCodigo, formato); // TODO: Verificar si está OK
        this.iva1 = this.neto_1 * (this.parametro_iva / 100);
        this.iva2 = this.neto_2 * (this.parametro_iva / 100);
        this.iva3 = this.neto_3 * (this.parametro_iva / 100);
        this.iva4 = this.neto_4 * (this.parametro_iva / 100);
        this.iva5 = this.neto_5 * (this.parametro_iva / 100);
        if (this.impuestoAdicPro > 0) {
          this.impAdicional1 = this.neto_1 * (this.impuestoAdicPro / 100);
          this.impAdicional2 = this.neto_2 * (this.impuestoAdicPro / 100);
          this.impAdicional3 = this.neto_3 * (this.impuestoAdicPro / 100);
          this.impAdicional4 = this.neto_4 * (this.impuestoAdicPro / 100);
          this.impAdicional5 = this.neto_5 * (this.impuestoAdicPro / 100);
        }
        else {
          this.impAdicional1 = 0;
          this.impAdicional2 = 0;
          this.impAdicional3 = 0;
          this.impAdicional4 = 0;
          this.impAdicional5 = 0;
        }
        this.preciofinal1 = this.iva1 + this.impAdicional1 + this.neto_1;
        this.preciofinal2 = this.iva2 + this.impAdicional2 + this.neto_2;
        this.preciofinal3 = this.iva3 + this.impAdicional3 + this.neto_3;
        this.preciofinal4 = this.iva4 + this.impAdicional4 + this.neto_4;
        this.preciofinal5 = this.iva5 + this.impAdicional5 + this.neto_5;
      } else {
        return
      }
    });
  }

  obtenerListaPrecioxFormato(producto: number, formato: string) {
    if (producto != null && formato != '') {
      let self = this;
      this.client.query({
        query: gql`
        query($empresa_rut:Decimal, $sucursal_codigo:Decimal,
          $producto_codigo:Decimal, $formato_codigo:String){
            lista_precio_detalle{
              obtenerListaPrecio(entidad:{
                empresa_rut:$empresa_rut
                sucursal_codigo:$sucursal_codigo
                producto_codigo:$producto_codigo,
                formato_codigo:$formato_codigo
              }){
                respuesta{
                  registros{
                    lista_precio_codigo
                    empresa_rut
                    sucursal_codigo
                    producto_codigo
                    formato_codigo
                    margen_ganacia_porcentaje
                    precio_neto
                    fecha_registro
                    precio_costo
                    precio_costo_penultimo
                    precio_costo_antepenultimo
                    fecha_modificacion
                    rut_usuario_creacion
                    rut_usuario_modificacion
                  }
                }
              }
            }
          }
        `,
        variables: {
          empresa_rut: this.rut_empresa,
          sucursal_codigo: this.sucursal_codigo,
          producto_codigo: producto,
          formato_codigo: formato
        },
        fetchPolicy: 'no-cache',
      }, function (respuesta) {
        const listaListaPrecioDetalle2 = respuesta.data.lista_precio_detalle.obtenerListaPrecio.respuesta.registros;
        if (listaListaPrecioDetalle2.length > 0) {
          listaListaPrecioDetalle2.forEach(element => {
            if (element.lista_precio_codigo == 1) {
              // self.formDatosComerciales.get('neto1').setValue(element.precio_neto);
              self.neto_1 = element.precio_neto;
              self.margen_1 = element.margen_ganacia_porcentaje;
            }
            if (element.lista_precio_codigo == 2) {
              // self.formDatosComerciales.get('neto2').setValue(element.precio_neto);
              self.neto_2 = element.precio_neto;
              self.margen_2 = element.margen_ganacia_porcentaje;
            }
            if (element.lista_precio_codigo == 3) {
              // self.formDatosComerciales.get('neto3').setValue(element.precio_neto);
              self.neto_3 = element.precio_neto;
              self.margen_3 = element.margen_ganacia_porcentaje;
            }
            if (element.lista_precio_codigo == 4) {
              // self.formDatosComerciales.get('neto4').setValue(element.precio_neto);
              self.neto_4 = element.precio_neto;
              self.margen_4 = element.margen_ganacia_porcentaje;
            }
            if (element.lista_precio_codigo == 5) {
              // self.formDatosComerciales.get('neto5').setValue(element.precio_neto);
              self.neto_5 = element.precio_neto;
              self.margen_5 = element.margen_ganacia_porcentaje;
            }
          });
        } else {
          // self.formDatosComerciales.get('neto1').setValue("");
          // self.formDatosComerciales.get('neto2').setValue("");
          // self.formDatosComerciales.get('neto3').setValue("");
          // self.formDatosComerciales.get('neto4').setValue("");
          // self.formDatosComerciales.get('neto5').setValue("");
          self.iva1 = 0
          self.impAdicional1 = 0;
          self.preciofinal1 = 0;
          self.iva2 = 0
          self.impAdicional2 = 0;
          self.preciofinal2 = 0;
          self.iva3 = 0
          self.impAdicional3 = 0;
          self.preciofinal3 = 0;
          self.iva4 = 0
          self.impAdicional4 = 0;
          self.preciofinal4 = 0;
          self.iva5 = 0
          self.impAdicional5 = 0;
          self.preciofinal5 = 0;
          // self.formDatosComerciales.get('margen1').setValue(0);
          // self.formDatosComerciales.get('margen2').setValue(0);
          // self.formDatosComerciales.get('margen3').setValue(0);
          // self.formDatosComerciales.get('margen4').setValue(0);
          // self.formDatosComerciales.get('margen5').setValue(0);
          self.neto_1 = 0;
          self.margen_1 = 0;
          self.neto_2 = 0;
          self.margen_2 = 0;
          self.neto_3 = 0;
          self.margen_3 = 0;
          self.neto_4 = 0;
          self.margen_4 = 0;
          self.neto_5 = 0;
          self.margen_5 = 0;
        }
      });
    }
  }

  loadAndShow(producto: producto, parametro_iva: number) {
    this.currentTabs = "detalle";
    this.producto = producto
    this.parametro_iva = parametro_iva
    this.resumenProductoModal.show();


    this.neto_1 = 0
    this.neto_2 = 0
    this.neto_3 = 0
    this.neto_4 = 0
    this.neto_5 = 0
    this.margen_1 = 0
    this.margen_2 = 0
    this.margen_3 = 0
    this.margen_4 = 0
    this.margen_5 = 0
    this.iva1 = 0
    this.impAdicional1 = 0;
    this.preciofinal1 = 0;
    this.iva2 = 0
    this.impAdicional2 = 0;
    this.preciofinal2 = 0;
    this.iva3 = 0
    this.impAdicional3 = 0;
    this.preciofinal3 = 0;
    this.iva4 = 0
    this.impAdicional4 = 0;
    this.preciofinal4 = 0;
    this.iva5 = 0
    this.impAdicional5 = 0;
    this.preciofinal5 = 0;
    this.formResumen.get('sku').disable();
    this.formResumen.get('codigo_barras').disable();
    this.formResumen.get('favorito').disable();
    this.formResumen.get('descripcion').disable();
    this.formResumen.get('descripcion_ext').disable();
    this.formResumen.get('unidad_medida').disable();
    this.formResumen.get('rubro').disable();
    this.formResumen.get('familia').disable();
    this.formResumen.get('unidad_negocio').disable();
    this.formResumen.get('formato').setValue("");
    this.codigo_impuesto = 0;
    this.formResumen.get('producto_codigo').setValue(producto.codigo);
    this.formResumen.get('empresa_rut').setValue(producto.empresa_rut);
    this.formResumen.get('sku').setValue(producto.sku);
    this.formResumen.get('descripcion').setValue(producto.descripcion);
    this.formResumen.get('descripcion_ext').setValue(producto.descripcion_ext);
    this.formResumen.get('es_exento').setValue(producto.es_exento);
    this.formResumen.get('codigo_barras').setValue(producto.codigo_barras);
    this.formResumen.get('fecha_registro').setValue(producto.fecha_registro);
    this.formResumen.get('favorito').setValue(producto.favorito);
    this.formResumen.get('tipo_producto_codigo').setValue(producto.tipo_producto_codigo);
    this.formResumen.get('unidad_medida').setValue(producto.unidad_medida_codigo);
    this.formResumen.get('afecto_reglas_comerciales').setValue(producto.afecto_reglas_comerciales);
    this.formResumen.get('fecha_caducidad_combo').setValue(producto.fecha_caducidad_combo);
    this.formResumen.get('fecha_inicio_combo').setValue(producto.fecha_inicio_combo);
    this.parametroUnidadNegocio();
    this.obtenerElementosProducto(producto.codigo);
    this.obtenerNombreElementosProducto(producto.rubro_codigo, producto.unidad_medida_codigo, producto.unidad_negocio_codigo);
  }

  obtenerElementosProducto(producto_codigo: number) {
    let self = this;
    this.client.query({
      query: gql`
      query($empresa_rut: Decimal, $producto_codigo:Decimal){
        familia{
          obtenerFamiliaProducto(
            entidad:{
              empresa_rut:$empresa_rut
            }, producto_codigo: $producto_codigo){
            respuesta{
              codigo
              nombre
              empresa_rut
              rubro_codigo
            }
          }
        }

        unidad_medida{
          obtenerUnidad_MedidaProducto(producto_codigo: $producto_codigo){
            respuesta{
              codigo
              nombre
            }
          }
        }

        producto_impuesto{
          obtenerSegunIdProducto(entidad:{empresa_rut:$empresa_rut,
            producto_codigo:$producto_codigo
          }){
            respuesta{
              empresa_rut
              producto_codigo
              impuesto_codigo
              fecha_registro
              factor
              valor
            }
          }
        }

        producto_formato{
          obtenerProductosFormatos(filtro:{
            exacto:{
              empresa_rut:$empresa_rut,
              producto_codigo:$producto_codigo,
            }
          }){
            respuesta{
              registros{
                empresa_rut
                producto_codigo
                formato_codigo
                formato_nombre
                peso_neto
                volumen
                fecha_registro
                cantidad
                activo
                formato_codigo_top
                formato_secundario
              }
            }
          }
        }
      }
      `,
      variables: {
        "empresa_rut": this.rut_empresa,
        "producto_codigo": producto_codigo
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      let codigo_familia = respuesta.data.familia.obtenerFamiliaProducto.respuesta.codigo;
      let nombre_familia = respuesta.data.familia.obtenerFamiliaProducto.respuesta.nombre;
      setTimeout(() => self.formResumen.controls["familia"].setValue(nombre_familia), 300);

      let codigo_unidad_medida = respuesta.data.unidad_medida.obtenerUnidad_MedidaProducto.respuesta.codigo;

      const seleccionProductoImpuestoJoin = respuesta.data.producto_impuesto.obtenerSegunIdProducto.respuesta;
      if (seleccionProductoImpuestoJoin != null) {
        self.codigo_impuesto = seleccionProductoImpuestoJoin.impuesto_codigo;
        self.impuestoAdicPro = seleccionProductoImpuestoJoin.valor;
      } else {
        self.codigo_impuesto = 0;
      }

      const listaProductoFormatoEditar = respuesta.data.producto_formato.obtenerProductosFormatos.respuesta.registros;
      self.listaProductoFormatoResumen = respuesta.data.producto_formato.obtenerProductosFormatos.respuesta.registros;
      self.optionsFormatoProducto = [];
      var sel: any;
      listaProductoFormatoEditar.forEach(element => {
        if (element.activo == true) {
          sel = { value: element.formato_codigo, label: element.formato_nombre };
          self.optionsFormatoProducto.push(sel);
        }
      });
      self.setDefaultFormat(listaProductoFormatoEditar)
    });
  }

  setDefaultFormat(listaProductoFormatoEditar) {
    // Default format
    const _lstFormatoCodigoTop = listaProductoFormatoEditar.filter(f => f.formato_codigo_top === f.formato_codigo)
    if (_lstFormatoCodigoTop.length > 0)
      this.formResumen.get('formato').setValue(_lstFormatoCodigoTop[0].formato_codigo)
    else if (listaProductoFormatoEditar.length > 0)
      this.formResumen.get('formato').setValue(listaProductoFormatoEditar[0].formato_codigo)
  }

  obtenerNombreElementosProducto(rubro_codigo: number, unidad_codigo: number, unidad_negocio_codigo: number) {
    let self = this;
    this.client.query({
      query: gql`
      query ($empresa_rut: Decimal, $rubro_codigo: Decimal, $unidad_codigo: Decimal, $unidad_negocio_codigo:Decimal) {
        rubro {
          obtenerSegunId(entidad: {empresa_rut: $empresa_rut, codigo: $rubro_codigo}) {
            respuesta {
              codigo
              descripcion
              empresa_rut
            }
          }
        }
        unidad_medida {
          obtenerSegunId(entidad: {codigo: $unidad_codigo}) {
            respuesta {
              codigo
              nombre
            }
          }
        }
        unidad_negocio{
          obtenerSegunId(entidad: {empresa_rut: $empresa_rut, codigo: $unidad_negocio_codigo}){
            respuesta{
              codigo
              nombre
            }
          }
        }
      }
      `,
      variables: {
        "empresa_rut": this.rut_empresa,
        "rubro_codigo": rubro_codigo,
        "unidad_codigo": unidad_codigo,
        "unidad_negocio_codigo": unidad_negocio_codigo
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      let descripcion_rubro = respuesta.data.rubro.obtenerSegunId.respuesta.descripcion;
      setTimeout(() => self.formResumen.controls["rubro"].setValue(descripcion_rubro), 300);

      if (respuesta.data.unidad_medida.obtenerSegunId.respuesta != null) {
        let nombre_unidad = respuesta.data.unidad_medida.obtenerSegunId.respuesta.nombre;
        setTimeout(() => self.formResumen.controls["unidad_medida"].setValue(nombre_unidad), 300);
      } else {
        self.formResumen.controls["unidad_medida"].setValue("")
      }
      if (respuesta.data.unidad_negocio.obtenerSegunId.respuesta != null) {
        let nombre_unidad_negocio = respuesta.data.unidad_negocio.obtenerSegunId.respuesta.nombre;
        setTimeout(() => self.formResumen.controls["unidad_negocio"].setValue(nombre_unidad_negocio), 300);
      } else {
        self.formResumen.controls["unidad_negocio"].setValue("")
      }
    });
  }

  showModalImpuestos() {
    this.modalSeleccionarImpuestos.loadAndShowOnlyView(this.codigo_impuesto)
  }

  capturaImpuesto(impuesto: number) {
    this.codigo_impuesto = impuesto;
  }
}
